import { render, staticRenderFns } from "./ForbidAnalytics.vue?vue&type=template&id=73b6d538"
import script from "./ForbidAnalytics.vue?vue&type=script&lang=js"
export * from "./ForbidAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports